import http from './http'

export default {

    /**
     * Get all facturas from promotor
     * @returns {Promise}
     */
    all() {
        return http.get('facturacion/facturas')
    },
}